<form *ngIf="customerForm" [formGroup]="customerForm" (ngSubmit)="onSubmit()" class="content-card">
  <mat-card class="form-card">
    <mat-card-content>

      <ng-container *ngIf="currentUserIsAdmin()">
        <div style="background-color: #47a3ff; padding: 10px; margin-bottom: 10px;">
          <mat-slide-toggle formControlName="isCollectionExempt">
            Exempt this customer from invoice collection
          </mat-slide-toggle>
        </div>
      </ng-container>

      <ng-container *ngIf="currentUserIsAdmin()">
        <div style="background-color: #ff8e47; padding: 10px; margin-bottom: 10px;">
          <mat-slide-toggle formControlName="preventAutoConversionToPhysical">
            Prevent automatic conversion of this customer's virtual cards to physical
          </mat-slide-toggle>
        </div>
      </ng-container>

      <ng-container *ngIf="currentUserIsAdmin()">
        <div style="background-color: #ffe647; padding: 10px; margin-bottom: 10px;">
          <mat-slide-toggle formControlName="isAutomaticLoadBlock">
            Block automatic loads for this customer
          </mat-slide-toggle>
        </div>
      </ng-container>

      <ng-container *ngIf="currentUserIsAdmin()">
        <div style="background-color: #ff8747; padding: 10px; margin-bottom: 10px;">
          <mat-slide-toggle formControlName="isAllLoadBlock">
            Block ALL loads for this customer
          </mat-slide-toggle>
        </div>
      </ng-container>

      <mat-form-field>
        <input matInput placeholder="Title" formControlName="title" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Sex" formControlName="sex" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="First name" formControlName="firstName" maxlength="50" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Last name" formControlName="lastName" maxlength="50" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Address" formControlName="address" maxlength="50" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="City" formControlName="city" maxlength="50" required>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Country" formControlName="countryIsoCode" required>
          <mat-option *ngFor="let country of countries" [value]="country.isoCode">{{country.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <input matInput placeholder="Zip code" formControlName="zipCode" maxlength="50" required>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Order language" formControlName="orderLanguage" required>
          <mat-option [value]="0">german</mat-option>
          <mat-option [value]="1">english</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Email" formControlName="email" maxlength="60" required email>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Nationality" formControlName="nationality" required>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Subscribed to news" formControlName="subscribeToNews" required>
          <mat-option [value]="true">Yes</mat-option>
          <mat-option [value]="false">No</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Mobile" formControlName="phone" [imask]="phoneMask" [unmask]="true" minlength="10" maxlength="15">
      </mat-form-field>
      <app-date-edit formControlName="dob"  placeholder="Date of birth"></app-date-edit>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-raised-button color="accent" type="button" (click)="returnBack()">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="!customerForm.valid || customerForm.pristine">Save</button>
    </mat-card-actions>
  </mat-card>
</form>
